<mat-card>
  <mat-card-content>
    <mat-card-title>Acessibilidade</mat-card-title>

    <div class="fs-14 align-j libras">
        <h3>Aumentar ou Diminuir a Fonte das Páginas do Sistema</h3>
        Basta utilizar os botões A+ ou A-
        <br />
        <img src="assets/images/custom/acessibilidade-libras.png" />
    </div>

    <div class="fs-14 align-j">
        <br />
        <h3>Acessível em Libras</h3>
        O sistema está acessível em Libras usando o VLibras, o tradutor automático da
        <br />
        Língua Portuguesa para a Língua Brasileira de Sinais.
        <br />
        <br />

    </div>

    <div class="fs-14 align-j">

        <h3>Como Funciona VLibras</h3>
        O VLibras é um conjunto de ferramentas usadas na tradução
        <br />
        automática do Português para LIBRAS. Ele pode ser usado em
        <br />
        computadores, celulares e páginas WEB.
        <br />
        <br />
        Você pode utilizar o VLibras com nosso sistema para leitura em libras.
        <br />
    </div>



    <div class="fs-14 align-j">
        <br />
        <h3>Instruções de Uso</h3>
        - Selecione o texto que deseja traduzir para LIBRAS
        <br />
        - Clique no texto selecionado com o botão direito, e em seguida clique no ícone do VLibras
        <br />
        - Assim que carregar será reproduzido o texto desejado em Libras
        <br />
        - Pode ser utilizado a funcionalidade de aumentar ou diminuir a velocidade e também pausar a qualquer momento

        <br />
        <br />
        Intruções para baixar, instalar e como utilizar estão disponiveis no site do VLibras. acesse o link:
        <br />
    </div>

    <div>
        <br />
        <div class="fs-14 align-j link">
            <a href="https://www.vlibras.gov.br" target="_blank" title="Voltar para a página inicial" ><< Site Oficial VLibras (vlibras.gov.br) >></a>
        </div>
    </div>
  </mat-card-content>
</mat-card>
